import * as Sentry from "@sentry/react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";

const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;
if (dsn) {
  Sentry.init({
    dsn,
    enabled: !!dsn,
    environment: import.meta.env.MODE,
    denyUrls: [
      /^chrome-extension:\/\//i,
      /^moz-extension:\/\//i,
      /^safari-extension:\/\//i,
      /^webkit-masked-url:\/\//i,
    ],
    ignoreErrors: [
      "MetaMask extension not found",
      "Failed to connect to MetaMask",
    ],
  });
}

createRoot(document.getElementById("root")!).render(<App />);
